import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <span className="relative flex size-9 items-center justify-center rounded-xl bg-brand-gradient text-primary-foreground shadow-glow animate-gradient-pan">
        <Check className="size-5" strokeWidth={3} />
      </span>
      {!compact && (
        <span className="text-lg font-extrabold tracking-tight">
          Visa<span className="text-gradient">Check</span>
        </span>
      )}
    </span>
  );
}

/** Soft animated colour blobs behind the app. */
export function Backdrop() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <div className="grid-pattern absolute inset-0 [mask-image:radial-gradient(ellipse_at_top,black_20%,transparent_70%)]" />
      <div className="absolute -left-40 -top-40 size-[520px] animate-float rounded-full bg-brand-sun/15 blur-3xl" />
      <div className="absolute -right-32 top-20 size-[460px] animate-float rounded-full bg-slate-400/15 blur-3xl [animation-delay:-3s]" />
      <div className="absolute bottom-0 left-1/3 size-[380px] animate-float rounded-full bg-amber-300/10 blur-3xl [animation-delay:-1.5s]" />
    </div>
  );
}
